module.exports = __webpack_public_path__ + "img/edith_blue.44f3166b.jpg";